/* Code was generated using AI assistance */
/**
 * Client-side filter for Apps / Settings launcher menus.
 * Matches label, path, keywords, and optionally group name.
 */
export function filterLauncherEntriesByQuery(items, query, { includeGroup = false } = {}) {
  const q = query.trim().toLowerCase();
  if (!q || !items?.length) return items || [];
  return items.filter((item) => {
    if ((item.label || "").toLowerCase().includes(q)) return true;
    if ((item.path || "").toLowerCase().includes(q)) return true;
    if (includeGroup && (item.group || "").toLowerCase().includes(q)) return true;
    const kws = item.keywords;
    if (Array.isArray(kws) && kws.some((k) => String(k).toLowerCase().includes(q))) return true;
    return false;
  });
}
